import React from 'react'
import { ICON_SIZE } from 'redesign/components/atoms/Icon/constants'
import { Container } from './styles'
import type { IconTextProps } from './types'

const TimelineIconText: React.FC<IconTextProps> = ({ icon: Icon, children, color, testId }) => (
  <Container data-testid={testId}>
    <Icon size={ICON_SIZE.extraSmall} color={color} isFilled />
    {children}
  </Container>
)

export default TimelineIconText
